<template>
  <div class="all_part">
    <div class="login_input">
      <div class="input_button">
        <div class="Logo">
          <img src="../assets/loginLogo1.png" style="width: 300px" alt="" />
        </div>
        <div class="loginInputs">
          <div class="userName">
            <el-input
               maxlength="11"
              v-model="phoneNum"

              placeholder="请输入手机号"
              type="number"
              style="width: 390px; margin-bottom: 20px"
            ></el-input>
            <img src="../assets/矢量智能对象(1).png" />
          </div>
          <div class="code">
            <el-input
              v-model="Password"
              placeholder="请输入验证码"
              style="width: 262px"
            ></el-input>
            <img src="../assets/矢量智能对象.png" alt="" />
            <el-button
              v-on:click="code"
              plain
              type="primary"
              :loading="codeStatus"
              style="width: 118px; height: 61px"
              >{{ codeStatus ? this.times + "s" : "发送验证码" }}
            </el-button>
          </div>
        </div>
        <div class="Login_button">
          <el-button
            type="primary"
            style="
              height: 56px;
              width: 390px;
              background-image: linear-gradient(to right, #358fe5, #1d6eb9);
              font-size: 22px;
              letter-spacing: 10px;
            "
            @click="login()"
            >登录
          </el-button>
        </div>
        <!--
        <div class="Login_button">
          <el-button
            type="primary"
            style="
              height: 56px;
              width: 390px;
              background-image: linear-gradient(to right, #358fe5, #1d6eb9);
              font-size: 22px;
              letter-spacing: 10px;
            "
            @click="openChat()"
            >客服
          </el-button>
        </div>
        -->
        <div class="Copyright_information">
          <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
        </div>
      </div>
<!--      <div class="Product_picture">-->
<!--        <img src="../assets/login_logo.png" alt="" />-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";
export default {
  data() {
    return {
      phoneNum: "",
      Password: "",
      userInfo: {},
      codeStatus: false,
      times: "60",
      key: 1,
    };
  },
  methods: {
    code() {
      console.log(this.phoneNum);
      if (this.phoneNum.length == 11) {
        this.codeStatus = true;
        let times = setInterval(() => {
          this.times = this.times - 1;
          if (this.times <= 0) {
            this.codeStatus = false;
            clearInterval(times);
          }
        }, 1000);

        this.axios
          .post(
            //  'https://localesdsys.issealing.com' + "/api/verification/code",
            //  'https://uatesdsys.issealing.com' + "/api/verification/code",
              'https://esdsys.issealing.com' + "/api/verification/code",
            this.$qs.stringify({
              phone: this.phoneNum,
            })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
      } else {
        this.$message("请输入正确的手机号");
      }
    },
    login() {
      this.axios;
      if (this.phoneNum.length == 11) {
        console.log("进来了");
        this.axios
          .post(
            httpUrl + "/api/login/login",
            this.$qs.stringify({
              phone: this.phoneNum,
              code: this.Password,
            })
          )
          .then((response) => {
            this.$message(response.data.message);
            if (response.data.code == 200) {
              if (response.data.data.type == 1) {
                console.log("进来了吗");
                localStorage.setItem(
                  "user",
                  JSON.stringify(response.data.data)
                );
              } else {
                sessionStorage.setItem(
                  "user",
                  JSON.stringify(response.data.data)
                );
                setTimeout(() => {
                  localStorage.removeItem("user");
                  sessionStorage.removeItem("user");
                  this.$router.replace("/LoginComputer");
                }, 43200000);
              }
              this.$router.push("/Main_menuComputer");
            } else {
              sessionStorage.setItem("user", "");
            }
            this.userInfo = response.data.data;
            console.log(this.userInfo);
          })
          .catch((error) => console.log(error, "error"));
      } else {
        this.$message("请输入正确的手机号");
      }
    },
    
    openChat() {
      var visiter_id = ''
      var visiter_name = ''
      var avatar = ''
      //let data = this.$u.user.getUser()
      //if (data) {
      //  visiter_id = data.user.user_code
      //  visiter_name = data.user.mobile ? data.user.mobile : ''
      //  avatar = data.user.head_pic ? data.user.head_pic : ''
      //}
      const web = encodeURI(
          'https://kflocal.gmors-shop.com/index/index/home?theme=FFFFFF&visiter_id=' +
          visiter_id +
          '&visiter_name=' +
          visiter_name +
          '&avatar=' +
          avatar +
          '&business_id=1&groupid=0'
      )
      window.open(web, '_blank')
    },

  },
};
</script>

<style>
</style>
<style scoped>
.Login_button >>> .el-button--primary {
  background-image: none!important;
  background-color: #00674f;
  border-color: #00674f;
}
.loginInputs >>> .el-input__inner {
  /* width:390px;*/
  height: 61px;
  padding-left: 36px;
  font-size: 18px;
}

.loginInputs {
  display: flex;
}

.all_part {
  //min-height: 900px;
  //min-width: 1920px;
  display: flex;
  align-items: center;
  justify-items: auto;
  position: absolute;
  background-image: url("../assets/loginBack.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  flex: 1;
}

.login_input {
  //box-shadow: 1px 10px 5px #888888;
  margin: 0 auto;
  //background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-content: center;
  width: 600px;
  height: 600px;
  justify-content: center;
}

.input_button {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.loginInputs {
  height: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.Product_picture {
  width: 50%;
}

.Product_picture img {
  height: 100%;
  width: 100%;
}

.code {
  width: 390px;
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  justify-content: space-between;
}

.userName {
  position: relative;
  display: flex;
  align-items: center;
}

.userName img {
  position: absolute;
  left: 8px;
  top: 16px;
}

.code img {
  position: absolute;
  left: 8px;
}
.Logo {
  margin-top: 20px;
}
</style>
